import React from "react";

// import {classCombinerFromPrefix, RenderableData, renderIdentifierGeneric} from "@/RenderIdentifier";
import classnames from "classnames";

import "@/app/pages/companyProfile/BusinessDirectoryOptout/BusinessDirectoryOptoutStyles.scss";

interface BusinessDirectoryOptoutComponentProps {
  companyName: string;
  headingText: string;
  linkClasses: string;
  linkHref: string;
  linkNewWindow: boolean;
  linkText: string;
}

interface ContactLinkParameters {
  cssClass: string;
  href: string;
  label: string;
  newWindow: boolean;
}

const InternalLinkComponent = (
  properties: ContactLinkParameters
): JSX.Element => (
  <a className={"link"} href={properties.href} title={properties.label}>
    {properties.label}
  </a>
);

const ExternalLinkComponent = (
  properties: ContactLinkParameters
): JSX.Element => (
  <a
    className={"link"}
    href={properties.href}
    rel="noreferrer"
    target="_blank"
    title={properties.label}
  >
    {properties.label}
  </a>
);

const ContactLinkComponent = (parameters: ContactLinkParameters): JSX.Element =>
  parameters.newWindow ? (
    <ExternalLinkComponent {...parameters} />
  ) : (
    <InternalLinkComponent {...parameters} />
  );

const replaceJsx = (
  string: string,
  replacement: Record<string, JSX.Element | string>
) => {
  const result: (JSX.Element | string)[] = [];

  const keys = window.Object.keys(replacement);

  const getRegExp = () => {
    const regexp: string[] = [];

    for (const key of keys) {
      regexp.push(`{${key}}`);
    }

    return new RegExp(regexp.join("|"));
  };

  const regExp = getRegExp();

  string
    .split(regExp)
    .forEach((st, nu) => result.push(st, replacement[keys[nu]!]!));

  return result;
};

export const BusinessDirectoryOptoutComponent = (
  props: BusinessDirectoryOptoutComponentProps
): JSX.Element => (
  <div className="component-wrapper">
    <div className="container-business">
      <div className="row-business">
        <div className="col-md-12 col-md-12-business-directory text-align-center spacing-sm-pt-4 spacing-sm-pb-4 spacing-pt-8 spacing-pb-8 spacing-pl-16 spacing-pr-16">
        <div className={"title"}>
          {replaceJsx(props.headingText, 
            {
              companyName: props.companyName,
              contactLink: (
                <ContactLinkComponent
                  cssClass={props.linkClasses}
                  key={props.linkText}
                  href={props.linkHref}
                  label={props.linkText}
                  newWindow={props.linkNewWindow}
                />
              ),
            })}
        </div>
        </div>
        </div>
    </div>
  </div>
);
